/**
 * <Form />
 *
 *
 * <Form onChange={onChange} />
 *
 *
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Field from './Field';
import classnames from 'classnames'
import getPresets from './getPresets';
import objectPath from 'object-path';

// fields
import DatePicker, {validateDatePicker} from './Fields/DatePicker';
import Gender from 'components/UI/Form/Fields/Gender';
import ReactSelect from 'components/UI/Form/Fields/ReactSelect';
import Address from 'components/UI/Form/Fields/Address';
import ClassBillingMethod, {validateClassBillingMethod} from 'components/UI/Form/Fields/ClassBillingMethod';
import DateTime from 'components/UI/Form/Fields/DateTime';
import SelectTeacher from 'components/UI/Form/Fields/SelectTeacher';
import SelectStudent from 'components/UI/Form/Fields/SelectStudent';
import ReactPhoneInput, {validatePhone} from 'components/Form/Fields/PhoneNumber';

import ImageUploader from 'components/Form/Fields/ImageUploader';

import Money from './Fields/Money';
import Email, { validateEmail } from './Fields/Email';
import Radio, { validateRadio } from './Fields/Radio';
import Name, { validateName, } from 'components/UI/Form/Fields/Name';
import Textarea from 'components/UI/Form/Fields/Textarea';
import Guardian, { validateGuardian } from 'components/UI/Form/Fields/Guardian';
import ObjectArray from 'components/Form/Fields/ObjectArray';
import MediaCenter from 'components/Form/Fields/MediaCenter';

import Openhours from 'components/UI/Form/Fields/OpenHours';
import Agelimit from 'components/UI/Form/Fields/AgeLimit';
import TimePicker2 from './Fields/TimePicker2';
import WeekdateSelect, { validateWeekdateSelect } from './Fields/WeekdateSelect';

const fieldValidations = {
  name: validateName,
  guardian: validateGuardian,
  email: validateEmail,
  radio: validateRadio,
  phone: validatePhone,
  classBillingMethod: validateClassBillingMethod,
  weekdateSelect: validateWeekdateSelect
}

const fields = {
  Name,
  Email,
  Guardian,
  DatePicker,
  Gender,
  Address,
  ImageUploader,
  DateTime,
  SelectTeacher,
  SelectStudent,
  ReactPhoneInput,
  ObjectArray,
  MediaCenter,
  Money,
  ClassBillingMethod,
  Textarea,
  ReactSelect,
  Openhours,
  Agelimit,
  Radio,
  TimePicker2,
  WeekdateSelect
}

import './Form.scss';
import './BasicFields.scss';

class Form extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.validate = this.validate.bind(this);

    this.formData = props.formData || {};
    this.formFieldRefs={}

    console.log(this.formData);
    this.state = {
      schema: [],
      failed: {},
    };
  }

  componentWillMount() {
    const {
      getValidationRef,
      schema,
      formData
    } = this.props;

    this.setState({
      schema: this.getSchemaFromPreset(schema),
    });

    if (typeof getValidationRef === 'function') {
      getValidationRef(this.validate);
    }
    if(formData){
      this.formData = formData;
      console.log(this.formData);
      this.forceUpdate();
    }
  }

  componentWillReceiveProps(props) {
    if (props.failed) {
      this.setState({
        failed: props.failed,
      });
    }

    if (props.schema) {
      this.setState({
        schema: this.getSchemaFromPreset(props.schema),
      });
    }

    if (props.formData) {
      this.formData = props.formData;
      this.forceUpdate();
    }
  }

  getSchemaFromPreset(schemaIn) {
    let presets = getPresets();

    return schemaIn.map((item)=>{
      let field;
      if (typeof item === "string" && presets[item]) {
        field = presets[item];
      } else if (item && typeof item.presetType=== "string" && presets[item.presetType]) {
        const existingField = presets[item.presetType] || {}

        field = {
          ...existingField,
          ...item, // overriding presetType settings
        };
      } else {
        field = {
          ...item,
        }
      }

      if (field) {
        return field;
      }
    });

  }

  onChange(path, value) {
    var parts = path.split('.');
    var o = this.formData;
    if (parts.length > 1) {
      for (var i = 0; i < parts.length - 1; i++) {
        if (!o[parts[i]])
            o[parts[i]] = {};
        o = o[parts[i]];
      }
    }

    o[parts[parts.length - 1]] = value;
    this.props.onChange(this.formData);
  }

  validate() {
    const {
      schema,
    } = this.state;

    let result = {
      ok: true,
      failed: {},
    }

    // Step 1. Validate
    schema.map((item, key)=>{
      const { name, validate = [], type } = item;
      const value = objectPath.get(this.formData, name);
      if (item.required === true && (typeof value == 'undefined' || value === '')) {
        result.ok = false;

        if (!result.failed[name]) {
          result.failed[name] = {
            because: [],
          };
        }

        result.failed[name].value = value;
        result.failed[name].because.push("required");
      }

      validate.map((rule)=>{
        let ok = true;
        let because;
        let message;

        if (typeof rule === "function") {
          const ruleResult = rule();
          ok = ruleResult.ok;
          because = ruleResult.because;
          message = ruleResult.message;
        } else if (typeof rule === 'string') {
          // ...need to do it
        }

        if (!ok) {
          if (!result.failed[name]) {
            result.failed[name] = {
              because: [],
            };
          }

          result.failed[name].value = value;
          result.failed[name].because.push(because);
          result.failed[name].message = message;
        }
      });

      if(typeof(fieldValidations[type]) == 'function'){
        const validationResult = fieldValidations[type](value)
        if(validationResult && validationResult.failed){
          result.ok = false
          result.failed[name] = validationResult.failed
        }
      }
    });

    //
    // Step 2. scroll to the first validation failure
    //
    this.scrollToFailed(result.failed);

    this.setState({
      failed: result.failed,
    });

    return result;
  }

  scrollToFailed(failed) {
    const {
      scrollingContainerRef,
    } = this.props;

    if (!scrollingContainerRef) {
      return;
    }

    const failedKeys = Object.keys(failed);

    if (failedKeys == 0) {
      return; // everything's good no need to scroll
    }

    const firstKey = failedKeys[0];

    const targetInput = ReactDOM.findDOMNode(this.formFieldRefs[firstKey]); // find the first input's DOM node with its ref

    const offsetTop = targetInput.getBoundingClientRect().top // get the offset top of the input

    const containerRef = ReactDOM.findDOMNode(scrollingContainerRef);

    containerRef.scrollTop = offsetTop;
  }

  render() {
    const {
      title,
      formStyle = 'inline',
    } = this.props;

    const {
      schema,
      failed,
    } = this.state;

    const formData = this.formData;

    return (
      <div className={classnames('Form', formStyle)}>
        { title && <h3>{title}</h3> }
        <section className='fields'>
          {schema.map((item, key)=>{
            let fieldData;
            const name = item.name;
            
            fieldData = objectPath.get(formData, name);

            if (typeof item.inputTransform === 'function') {
              fieldData = item.inputTransform(fieldData, formData);
            }

            return <Field
              fields={fields}
              item={item}
              failed={failed[name]}
              fieldData={fieldData}
              formData={formData}
              onChange={this.onChange}
              formStyle={formStyle}
              key={key}
              ref={(r)=>{
                if (r) {
                  this.formFieldRefs[name]=r;
                }
              }}
            />
          })}
        </section>
      </div>
    )
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/index.js